import styles from './header.module.scss';
import React from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { StoreUtils } from '../../../utils/util';
import Icon from '../../../components/FormControl/Icon';
import { TableIconButton } from '../../../components/Styled';
import { useLocation, useNavigate } from 'react-router-dom';
import ShopSection from './ShopSection';
import HelpSection from './HelpSection';
import LearnMoreSection from './learnmore';
import NotificationSection from './NotificationSection';
import useIdleTimeout from '../../../hooks/useIdleTimeout';
import { localStore } from '../../../services/browserStorage';
// import TabConnect from './TabConnect';
// import { ACCESS_CONTROL_KEYS_ENUM, UserAccessControlData } from 'utils/accessControl';
// import AnnouncementModal from '../../../components/Dialoges/AnnouncementModal';
import { ACCESS_CONTROL_KEYS_ENUM, UserAccessControlData } from 'utils/accessControl';
import TabConnect from './TabConnect';
import RefreshDialog from 'components/Dialoges/RefreshDialog';

const PATH_MAP: Record<string, string> = {
  '': 'Bill Entry',
  'bill-entry': 'Bill Entry',
  wholesale: 'WholeSale',
  'wholesale-return-billing': 'Wholesale Return',
  'wholesale-return-history': 'Wholesale Return History',
  order: 'Online Order',
  dunzo: 'Dunzo Catalogue',
  'bank-transfers': 'Bank Transfers',
  'online-orders': 'Online Order',
  'sales-order': 'Sales Order',
  'sales-order-history': 'Sales Order History',
  'bill-history': 'Bill History',
  'order-history': 'Online Order History',
  'sales-return': 'Sales Return',
  'sales-return-history': 'Sales Return History',
  'purchase-entry': 'Purchase Entry',
  'purchase-order': 'Purchase Order',
  'purchase-history': 'Purchase History',
  'purchase-return': 'Purchase Return',
  'purchase-return-history': 'Purchase Return History',
  suppliers: 'Suppliers',
  'cheque-payment': 'Cheque Payment',
  customers: 'Customers',
  doctors: 'Doctors',
  'payments-history': 'Payments History',
  'paytm-history': 'Paytm History',
  inventory: 'Inventory',
  'sku-master': 'Sku Master',
  'bulk-carton-label-print': 'Bulk Carton Label Print',
  'medicine-wikipedia': 'Med Wiki',
  'merge-duplicate': 'Merge Duplicates',
  'item-mapping': 'Item Mapping',
  report: 'Reports',
  // Stock Reports
  'batchwise-stock-report': 'Stock report',
  'expiry-report': 'Expiry report',
  'stock-adjustment-report': 'Stock adjustment report',
  'non-moving-items-report': 'Non moving items report',
  'item-mapping-report': 'Item mapping report',
  'low-stock-report': 'Low stock report',
  'schedule-type-report': 'Schedule report',
  'new-items-report': 'New item report',
  'itemwise-stock-report': 'Itemwise Stock Report',
  'enquiry-report': 'Enquiry report',
  'opening-stock-report': 'Opening Stock Report',
  'item-master-report': 'Item master report',
  'stock-audit-report': 'Stock Audit Report',

  // Sales Reports
  'oversold-report': 'Oversold report',
  'itemwise-sales-margin-report': 'Itemwise sales margin report',
  'batchwise-sales-report': 'Batchwise sales report',
  'itemwise-sales-report': 'Itemwise sales report',
  'shift-management-report': 'Shift management report',
  'staffwise-sales-report': 'Staffwise sale report',
  'salesperson-incentive-report': 'Salesperson Incentive Report',

  // Purchase Reports
  'batchwise-purchase-report': 'Batchwise purchase report',
  'overbought-report': 'Overbought Report',
  'store-bounced-items-report': 'Bounce Item Report',
  'branch-po-tracking-report': 'Branch-PO Report',
  'brand-po-fill-rate-report': 'Brand PO Fill Rate Report',
  'supplier-due-date-report': 'Supplier Due Date Report',
  'grn-history-report': 'GRN History Report',

  // Stock Transfer Reports
  'batchwise-stock-transfer-report': 'Batchwise Stock Transfer Report',

  // GST Reports
  'gstr-sales-report': 'GSTR Sales Report',
  'gstr-purchase-report': 'GSTR Purchase Report',
  'gstr1-report': 'GSTR-1 Report',
  'gstr3b-report': 'GSTR-3B Report',
  'gstr2a-report': 'GSTR-2A Report',

  'fkh-report': 'FKH Report',
  'tally-master-report': 'Tally Master',
  'tally-transaction-report': 'Tally Transaction',
  'daily-summary-report': 'Daily Summary Report',
  'wanted-note': 'Wanted note',
  'wanted-note-history': 'Wanted Note History',
  'cash-bank-book': 'Cash & Bank Book',
  coupon: 'Coupon',
  'manage-expenses': 'Manage expenses',
  dashboard: 'Dashboard',
  'analytics-dashboard': 'Analytics Dashboard',
  masters: 'Masters',
  viewPayment: 'View Payment',
  'store-profile': 'Store Profile',
  settings: 'Settings',
  'stock-transfer': 'Stock Transfer',
  'transfer-details': 'Transfer Details',
  branches: 'Branches',
  'generated-report': 'Generated Report',
  'pre-printed-configuration': 'Pre Print Configuration',

  //  Delivery partner
  'delivery-partner': 'Delivery Partner',
  'delivery-task': 'Delivery Task',
  // Staff Management
  'staff-management': 'Staff Management',

  // wms
  wms: 'WMS',
};

const SUB_PATH: Record<string, string> = {
  'bill-entry': 'Wholesale Bill Entry',
  'bill-history': 'Wholesale Bill History',
  retailers: 'Wholesale Retailers',
  'sales-person': 'Sales Person',
  'po-fulfillment': 'PO Fulfillment',
  // wms
  'grn-history': 'GRN History',
  'grn-entry': 'GRN Entry',
  'picklist-history': 'Picklist History',
  'putaway-history': 'Putaway History',
  // fkh
  'invoice-order': 'Invoice Order',
  'online-order': 'Online Order',
  'invoice-details': 'Invoice Details',
  // Item Mapping
  'admin-panel': 'Admin Panel',
  'map-items': 'Map Items',
};

// // Key for storing announcement modal shown status
// const ANNOUNCEMENT_MODAL_KEY = 'hsn_gst_announcement_shown';

const Header: React.FC<{ onIdxChange: (idx: number) => void }> = (props) => {
  // const [showAnnouncementModal, setShowAnnouncementModal] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { show } = useIdleTimeout();
  const planStatus = localStore.get('currentPlanStatus');

  // Header location split for report
  const path =
    location.pathname.includes('report') || location.pathname.includes('wms')
      ? location.pathname.split('/').pop()
      : location.pathname.split('/')[1];

  const subPath = location.pathname.split('/')?.[2];

  /**
   * sub path mapping is there then will show subpath or else path
   */
  const pathName = SUB_PATH[subPath] || (path ? PATH_MAP[path] : '');
  const {
    session: { userData },
  } = StoreUtils.getActiveSession();

  const screenKey = SUB_PATH[subPath] ? `${path}/${subPath}` : path ?? '';

  // // Check if announcement modal should be shown
  // React.useEffect(() => {
  //   const hasSeenAnnouncement = localStore.get(ANNOUNCEMENT_MODAL_KEY);
  //   if (!hasSeenAnnouncement) {
  //     const timer = setTimeout(() => {
  //       setShowAnnouncementModal(true);
  //     }, 1000);

  //     return () => clearTimeout(timer);
  //   }
  // }, []);

  // const handleCloseAnnouncementModal = () => {
  //   if (show) {
  //     handleResetIdleTimer();
  //   } else if (showAnnouncementModal) {
  //     setShowAnnouncementModal(false);
  //     localStore.set(ANNOUNCEMENT_MODAL_KEY, true);
  //   }
  // };

  return (
    <header>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        className={styles.header}
      >
        <Stack direction='row' alignItems='center' spacing={1}>
          {/* Back Button */}
          <Tooltip title={'Go Back'}>
            <TableIconButton onClick={() => navigate(-1)}>
              <Icon icon={'ri-arrow-go-back-line'} size={'1.2rem'} />
            </TableIconButton>
          </Tooltip>
          {/* Change Active Shop */}
          <ShopSection onIdxChange={props.onIdxChange} />

          <Stack direction='row' alignItems='center'>
            <Icon icon={'ri-arrow-right-s-fill'} />
            <Typography variant='subtitle1' className={styles.path}>
              {pathName}
            </Typography>
          </Stack>
        </Stack>
        <div>
          {planStatus !== 'active' && (
            <Stack direction='row' alignItems='center' spacing={0}>
              <Icon icon={'ri-error-warning-line'} color='#d32926' />
              <p className={styles.planStatus}>{localStore.get('planStatusMsg')}</p>
            </Stack>
          )}
        </div>

        <Stack direction='row' alignItems='center' spacing={0}>
          {/* Help Section */}
          {planStatus == 'active' && (
            <Box mr={1}>
              <Stack
                direction='row'
                alignItems='center'
                component='a'
                href='https://webstore.1pharmacy.io/dermatouch_coud_wellness_pvt_ltd/items?listBy=category&type=combo%20for%201st%20retailers'
                target='_blank'
                sx={{
                  textDecoration: 'none',
                  color: '#2e6acf',
                  cursor: 'pointer',
                }}
              >
                <Icon icon='ri-error-warning-line' />
                <p className={styles.dermatouchInfo}>Dermatouch: Place Order Now!</p>
              </Stack>
            </Box>
          )}

          <span className={styles.userInfo}>Hi, {userData.name}</span>
          {!UserAccessControlData.get(ACCESS_CONTROL_KEYS_ENUM.ENABLE_CUSTOMER_TAB) && (
            <TabConnect />
          )}
          <HelpSection />
          <LearnMoreSection screenKey={screenKey} />
          <NotificationSection />
        </Stack>
      </Stack>

      {show ? <RefreshDialog open={show} /> : null}

      {/* Announcement Modal */}
      {/* {show || showAnnouncementModal ? (
        <AnnouncementModal
          open={show || showAnnouncementModal}
          onClose={handleCloseAnnouncementModal}
        />
      ) : null} */}
    </header>
  );
};

export default Header;
